/* eslint-disable no-unused-vars */
export enum ColumnTypeEnum {
  date,
  dropdowns,
  text,
  currency,
  number,
  boolean,
  booleanWithFalse
}